export class Competitor {
  _id?: string;
  name?: string;
  age?: any;
  cpf?: string;
  gender?: string;
  professional?: boolean;
  email?: string;
}
